import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import { SESSION_USER, REDIRECT_PATH_ON_AUTH } from 'utils/constants'
import { isNoMainMenuFromV4 } from 'utils/functions'
import { getV4Path, RouteName } from './config'

import { Omega, OmegaEventIds, OmegaBusiness, OmegaStatus } from 'common/omega'
function isSapConcurRoute (params) {
  const regex = /\?id=(.+)?&requestToken=(.+)/
  const isSapConcurURL = regex.test(location.search)

  if (isSapConcurURL) {
    const origin = location.origin
    const [, id, requestToken] = location.search.match(regex)
    location.href = `${origin}/#/sap-concur-integration?id=${id}&requestToken=${requestToken}`
  }

  return isSapConcurURL
}

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  },
  routes
})

router.beforeEach((to, from, next) => {
  try {
    Omega.trackEvent(OmegaEventIds.tech_b2b_v3_router_en, {
      route_path_name: to.name
    })
  } catch (e) {
    console.log(`tech_b2b_v3_router_en埋点上报报错：${e}`)
  }
  try {
    if (from && from.name === 'Login') {
      // 登录结束，跳转到其他页面
      Omega.trackBusiness(OmegaEventIds.tech_b2bv3_login, {
        business: OmegaBusiness.login,
        type: 'all',
        status: OmegaStatus.success
      })
    }
  } catch (e) {
    console.log(`登录成功跳转错误埋点上报：${e}`)
  }
  const publicRoutes = routes
    .filter(route => route.name)
    .filter(route => !route.meta || (route.meta && !route.meta.requiresAuth))
    .map(route => route.name)

  const isPublicRoute = Boolean(publicRoutes.find(route => route === to.name))
  const isPrivateRoute = !publicRoutes.includes(to.name)
  const loggedIn = localStorage.getItem(SESSION_USER)

  if (isSapConcurRoute()) return

  if (
    to &&
    (to.name === 'ExpiredLink' || to.name === 'CheckLink' || to.name === 'SAPConcurIntegration')
  ) {
    return next()
  }

  if (!loggedIn) {
    if (isPublicRoute) return next()

    if (isPrivateRoute) {
      // save current route on local storage
      localStorage.setItem(REDIRECT_PATH_ON_AUTH, location.hash.replace(/^#/, ''))

      // redirect to login
      // // location.href = `${location.origin}/#/login`
      // v4嵌入v3的页面，如果token过期，直接跳到v4首页，不要展示v3的登录页面
      if (isNoMainMenuFromV4()) {
        window.navigateToReact(getV4Path(RouteName.Home, to))
        return false
      }
      return next('/login')
    }
  }

  // user is logged but route is public
  if (isPublicRoute) return next({ name: 'Home' })

  next()
})

export default router
